export default "__VITE_ASSET__cZciiqK2__"